import clsx from "clsx";
import React from "react";
import { createPluggable } from "pluggable-react";
import styles from "./Pressable.module.scss";
import { Slot } from "@radix-ui/react-slot";
import { withRefProp } from "../../../utils/withRefProp";
import Ripple, { type RippleProps } from "./ripple/Ripple";

export interface PressableProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    className?: string;
    ref?: React.Ref<HTMLButtonElement>;
    asChild?: boolean;
}

const DefaultPressable = withRefProp((props: PressableProps) => {
  const { className, children, ref, asChild, ...otherProps } = props;
  const Component = asChild ? Slot : "button";
  if (asChild) {
    return (
      <Slot
        ref={ref as React.Ref<HTMLElement>}
        className={clsx(styles.pressable, className)}
        data-deci-pressable="true"
        {...otherProps}
      >
        {children}
      </Slot>
    );
  }

  return (
    <Component
      ref={ref}
      type="button"
      className={clsx(styles.pressable, className)}
      data-deci-pressable="true"
      {...otherProps}
    >
      {children}
    </Component>
  );
});

const Pressable = createPluggable<PressableProps>("deci.pressable", DefaultPressable);

export type { RippleHandle } from "./ripple/Ripple";
export type PressableRippleProps = RippleProps;

const PressableRipple = createPluggable<PressableRippleProps>("deci.pressable.ripple", Ripple);

export default Object.assign(Pressable, {
    Ripple: PressableRipple,
});
